import { Component } from 'shimmer'
import { Vector3, MeshPhongMaterial, Color, DoubleSide } from 'three'

import { Loader } from '@/utils/Loader'

export class BodyPart extends Component {
  constructor ({ url }) {
    super({ name: 'bodypart' })

    this.url = url

    this.promise = new Promise(resolve => {
      this.resolve = resolve
    })

    this.promises = []

    this.colorObject = this.colorObject.bind(this)
    this.destroy = this.destroy.bind(this)
    
    this.promises.push(Loader.load(this.url).then(object => {
      this.object = object
      this.add(this.object)
      this.colorObject()
      // this.normalizeSize()
    }))

    Promise.all(this.promises).then(this.resolve)

    this._basePos = new Vector3(0, 0, 0)
  }

  // TEMP
  normalizeSize () {
    const targetHeight = 1
    this.object.scale.set(1, 1, 1)

    const box = this.relativeBoundingBox
    const size = new Vector3()
    box.getSize(size)

    let ratio = targetHeight / size.y

    this.object.scale.set(ratio, ratio, ratio)
  }

  set basePos (pos) {
    this.position.sub(this._basePos)
    this._basePos.copy(pos)
    this.position.add(pos)
  }

  colorObject () {
    if (this.object && this._color) {
      this.object.traverse(item => {
        if (item.isMesh) {
          if (item.name.startsWith('Skin_')) {
            item.material.dispose()
            item.material = new MeshPhongMaterial({
              color: new Color('#' + this._color)
            })
          }
          // item.material.transparent = true
          item.material.side = DoubleSide
          item.material.depthTest = true
          item.material.depthWrite = true
        }
      })
    }
    this.opacity = this._opacity
  }

  set color (color) {
    this._color = color
    this.colorObject()
  }

  get opacity () {
    return this._opacity
  }

  set opacity (opacity) {
    this._opacity = opacity
    this.traverse((child) => {
      if (child.isMesh) {
        child.material.opacity = opacity

        if (opacity === 1) {
          child.material.transparent = false
        }
        else {
          child.material.transparent = true
        }
      }
    })

    if (opacity === 0) {
      // this.scale.set(0, 0, 0)
    }
    else {
      this.scale.set(1, 1, 1)

    }
  }

  onDestroy () {
    this.traverse((child) => {
      if (child.isMesh) {
        child.material.dispose()
        child.geometry.dispose()
      }
    })
    this.destroy()
  }
}